/** DN hợp lệ phải có ID dương; không chấp nhận nhóm "Khác" của V1. */
export function hasPageBusiness(page: {businessId?: unknown} | null | undefined): boolean {
  const value = page?.businessId;
  return (typeof value === 'number' || typeof value === 'string')
    && Number.isFinite(Number(value)) && Number(value) > 0;
}

/** Kiểm tra từng Page trong session BE, không suy ra từ DN đang chọn. */
export function joinedPagesHaveBusinesses(data: any): boolean {
  const pages: {id?: unknown; businessId?: unknown}[] = Array.isArray(data?.pages)
    ? data.pages
    : data?.pages && typeof data.pages === 'object' ? Object.values(data.pages) : [];
  if (!pages.length || !pages.every(hasPageBusiness)) return false;
  const ids = new Set(pages.map(page => String(page.id ?? '')));
  return !Array.isArray(data?.pageIds)
    || data.pageIds.every((id: unknown) => ids.has(String(id)));
}
